export const getStopStatusValue = (statusValue) =>
  typeof statusValue === "object" && statusValue !== null
    ? statusValue.value || ""
    : statusValue || "";

export const normalizeStatusChangeImageUrls = (statusChange = {}) =>
  Array.isArray(statusChange.imageUrls)
    ? statusChange.imageUrls.filter(Boolean)
    : [];

export function translateStopStatusOptions(status) {
  switch (status) {
    case "LOADING_PENDING":
      return { value: "LOADING_PENDING", label: "Criado, não iniciado" };
    case "HEADING_TO_PICKUP":
      return {
        value: "HEADING_TO_PICKUP",
        label: "Deslocando-se para a coleta",
      };
    case "WAITING_LOADING":
      return { value: "WAITING_LOADING", label: "Aguardando carregamento" };
    case "WAITING_DOCUMENTATION":
      return {
        value: "WAITING_DOCUMENTATION",
        label: "Aguardando documentação",
      };
    case "LOADING_COMPLETED":
      return { value: "LOADING_COMPLETED", label: "Carregamento finalizado" };
    case "UNLOADING_PENDING":
      return { value: "UNLOADING_PENDING", label: "Criado, não iniciado" };
    case "WAITING_UNLOADING":
      return { value: "WAITING_UNLOADING", label: "Aguardando descarga" };
    case "UNLOADING_COMPLETED":
      return { value: "UNLOADING_COMPLETED", label: "Descarga finalizada" };
    default:
      return [];
  }
}

export function resolveStopStatusOption(status, options = []) {
  const statusValue = getStopStatusValue(status);
  const translatedStatus = translateStopStatusOptions(statusValue);

  return (
    options.find((option) => option.value === statusValue) ||
    (!Array.isArray(translatedStatus) ? translatedStatus : null)
  );
}

export function buildStoppingPointStatusChangePayload({
  index,
  stop,
  originalStop,
  field,
  value,
  options = [],
  user = {},
  authorization = {},
  changedAt = new Date().toISOString(),
}) {
  const previousStatus = getStopStatusValue(originalStop?.[field]);
  const nextStatus = getStopStatusValue(value);
  const nextStatusOption = resolveStopStatusOption(nextStatus, options);
  const previousStatusOption = resolveStopStatusOption(previousStatus, options);
  const imageUrls = Array.isArray(authorization?.imageUrls)
    ? authorization.imageUrls.filter(Boolean)
    : [];

  return {
    stoppingPointIndex: index,
    stoppingPointId: stop?.id || "",
    numberCollect: stop?.number_collect || "",
    stopOrder: stop?.stop_order || index + 1,
    operation: stop?.operation || "",
    field,
    previousStatus,
    previousStatusLabel: previousStatusOption?.label || "",
    status: nextStatus,
    statusLabel: nextStatusOption?.label || "",
    user,
    authorizedBy: authorization?.authorizedBy || null,
    reason: String(authorization?.reason || "").trim(),
    imageUrls,
    changedAt,
  };
}
